// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WWpo","importantInfo":"styles_importantInfo__23dsx"};